import React from 'react';
import { Currency, UnitOfMeasure } from '../../../../Generated/Raven-Demeter';
import { IExchangeCommoditySelection } from '../../../Components/Navigation/Hooks/useExchangeCommodityNavigationHook';
import { IFuturesPriesComparisonChartProps } from '../../Futures/Prices/FuturesPricesComparisonChart';
import { IWithPageElementProps } from '../DashboardCustomizationDefinitions';

const withFuturesPricesForwardCurveChartFromPageElement = (
    FuturesPriesComparisonChart: React.ComponentType<IFuturesPriesComparisonChartProps>,
): React.FC<IWithPageElementProps> => {
    const Wrapped: React.FC<IWithPageElementProps> = (props) => {
        if (!props.pageElement) {
            return <> </>;
        }

        const { demeterPageElementGuid, commodity, exchange, currency, unitOfMeasure } = props.pageElement;

        const exchangeCommoditySelection = {
            exchange,
            commodity,
        } as IExchangeCommoditySelection;

        const chartProps: IFuturesPriesComparisonChartProps = {
            exchangeCommoditySelection,
            customTitle: props.customTitle,
            currency: currency ?? Currency.Usd,
            unitOfMeasure: unitOfMeasure ?? UnitOfMeasure.MetricTon,
            testId: `dashboard-futures-prices-comparison-chart-${demeterPageElementGuid}`,
            dragIndicatorIcon: props.dragIndicatorIcon,
            isInDashboardEditMode: props.isInDashboardEditMode,
            maximizeMinimizeButton: props.maximizeMinimizeButton,
            maxWidthHeightRatio: props.maxWidthHeightRatio,
            handleMoreOptionsSelection: props.handleMoreOptionsSelection,
            track: props.track,
        };

        return <FuturesPriesComparisonChart {...chartProps} />;
    };

    return Wrapped;
};

export default withFuturesPricesForwardCurveChartFromPageElement;
